import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CompanyInformationValidationService {
  validateCnpj(cnpj: string): boolean {
    return cnpj.length === 14;
  }

 formatCnpj(cnpj: string): string {
  return cnpj
    .replace(/[^a-zA-Z0-9]+/g, "") 
    .replace(/^([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})([a-zA-Z0-9]{2})/, "$1.$2.$3/$4-$5"); 
 }

  cleanCnpj(cnpj: string): string {
    return cnpj.replace("-", "").replace(/[^a-z\d]+/gi, "");
  }
}